import { useContext, useState } from "react";
import NavigationBar from "../../../navigation_components/NavigationBar";
import "../../../../styles/workspace_styles/CustomerUserStyles/Accounts/Account.css";
import Profile from "./Profile";
import Security from "./Security";
import BottomRightMessageBox from "../../UniversalComponents/BottomRightMessageBox";
import CustomerUserSideBar from "../../../sidebar_components/CustomerUserSideBar";
import { AppContext } from "../../../AppProvider";

const Account = () =>{
    const {customerIotProfile} = useContext(AppContext);
    const [selectedAccountTab,setSelectedAccountTab] = useState('profile');
    return(
        <div className="customer-user-account-page">
            <NavigationBar/>
            <div className="customer-user-account-page-layout">
                <div style={{display: customerIotProfile?.defaultDashboardAlwaysFullScreen? 'none':'block'}}>
                    <CustomerUserSideBar/>
                </div>
                <div className="customer-user-account-parent-container">
                    <div className="customer-user-account-container">
                        <div className="customer-user-account-navigation-bar">
                            <button className={selectedAccountTab === 'profile'? 'active':''}
                                onClick={() =>setSelectedAccountTab('profile')}>
                                <img src={`${process.env.PUBLIC_URL}/images/user-icon-blue.png`}/>
                                <p>Profile</p>
                            </button>
                            <button className={selectedAccountTab === 'security'? 'active':''}
                                onClick={() => setSelectedAccountTab('security')}>
                                <img
                                    src={`${process.env.PUBLIC_URL}/images/security-config-icon.png`}
                                />
                                <p>Security</p>
                            </button>
                        </div>
                        <div className="customer-user-account-body">
                            {selectedAccountTab === 'profile'? <Profile/>:<Security/>}
                        </div>
                    </div>
                </div>
            </div>
            <BottomRightMessageBox/>
        </div>
    );
};
export default Account;